<template>
    <v-container fluid class="text-xs-center"> 
        <v-layout row wrap>
            <v-form>
                <v-container>
                    <div class="vrow">
                        <h4>Dati del cliente</h4>
                        <v-text-field
                            v-model="customer.name"
                            :counter="40"
                            label="Nome"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.lastname"
                            :counter="40"
                            label="Cognome"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.telephone"
                            :counter="15"
                            label="Telefono"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.mobilePhone"
                            :counter="15"
                            label="Cellulare"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.email"
                            :counter="64"
                            label="E-mail"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.birthPlace"
                            :counter="40"
                            label="Luogo di nascita"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.birthday"
                            type="date"
                            label="Compleanno"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.fiscalCode"
                            :counter="18"
                            label="Codice fiscale"
                            required
                        ></v-text-field>
                    </div>
                    <div class="vrow">
                        <h4>Indirizzo di residenza</h4>
                        <v-text-field
                            v-model="customer.residenceStreet"
                            :counter="40"
                            label="Via / Corso / Piazza"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.residenceStreetNumber"
                            :counter="5"
                            label="N° Civico"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.residenceZipCode"
                            :counter="5"
                            label="CAP"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.residenceCity"
                            :counter="40"
                            label="Città"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="customer.residenceProvince"
                            :counter="2"
                            label="Provincia (2 lettere)"
                            required
                        ></v-text-field>
                        
                    </div>
                </v-container>
            </v-form>
        </v-layout>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            color="green"
            style="bottom:20px;"
            @click.native="createCustomer()"
            > <v-icon style="font-size:40px;padding-top:5px;">check</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'CustomerAdd',
    data: function(){
        return{
            customer:{
                name:null,
                lastname:null,
                fiscalCode:null,
                birthday:null,
                email:null,
                telephone:null,
                mobilePhone:null,
                birthPlace:null,
                residenceStreet:null,
                residenceStreetNumber:null,
                residenceZipCode:null,
                residenceCity:null,
                residenceProvince:null
            }
        };
    },
    mounted: function(){
        let vm = this;
    },
    methods:{
        createCustomer(){
            let vm = this;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "createCustomer.php",
                data: vm.customer,
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'customer', params:{customerId:response.data.id}});
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>

<style>
.vrow{
    display: inline-block;
    width:48%;
    padding-right:2%;
    vertical-align: top;
}
@media all and (max-width:500px){
    .vrow{
        width:100%;
        padding-right:0;
    }
}
.v-form{
    width:100%;
}
h4{
    font-size: 20px;
}
</style>
